<template>
  <div class="text-center d-inline-flex fluid">
    <v-menu v-model="menu" :close-on-content-click="false" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <v-btn size="small" variant="text" v-bind="props" :class="{ active: menu }">
          {{ filterName }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card min-width="290px">
        <v-card-text>
          <p>{{ availableHoursRange[0] }} - {{ availableHoursRange[1] }}</p>
          <v-range-slider
            v-model="range"
            :min="availableHoursRange[0]"
            :max="availableHoursRange[1]"
            step="1"
            prepend-icon="mdi-engine"
            @end="onChange"
          ></v-range-slider>
          <p>Selected Range: {{ range[0] }} h ~ {{ range[1] }} h</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="onOk">
            {{ $t("common.actions.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["filterName", "availableHoursRange", "selectedHoursRange"],
  emits: ["update:selectedHoursRange"],
  data: () => ({
    menu: false,
    range: [0, 0]
  }),
  created() {
    this.range = this.availableHoursRange
  },
  methods: {
    onOk() {
      this.menu = false
    },
    onChange() {
      this.$emit("update:selectedHoursRange", this.range)
    }
  },
  watch: {
    selectedHoursRange(newSelection) {
      this.range = newSelection
    }
  }
}
</script>

<style>
.v-btn.active .v-icon {
  transform: rotate(-180deg);
}
</style>
